<template>
  <div class="col-span-full">
    <div class="w-full bg-white dropdown">
      <div class="container mx-auto">
        <div v-bind:class="{'grid dropdown-images': secondary && secondary.length > 0,  '': !secondary && secondary.length > 0}">
          
            <ul class="grid">
              <li v-for="subMenu in primary" :key="subMenu.id" @click="hideDropdown()">
                <NuxtLink :to="subMenu.slug">
                  {{ subMenu.name }}
                </NuxtLink>
              </li>
            </ul>
          
          <div class="menu-border-left dropdown-list" v-if="secondary && secondary.length > 0">
            <h4 class="my-3 pb-3" v-text="menu.secondary_child_menu_items_title"></h4>
            <ul class="grid grid-cols-1 multiline">
              <li v-for="subMenu in secondary" :key="subMenu.id" @click="hideDropdown()">
                <NuxtLink :to="subMenu.slug">{{ subMenu.name }}</NuxtLink>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div v-if="menu.name == 'Pest Control' && menu.disclaimer != null" class="container mx-auto text-left">
        <p>{{menu.disclaimer}}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useNuxtApp } from '#app';

// Props
const props = defineProps({
  menu: Object
});

const { $config } = useNuxtApp();

// Reactive state
const imageLocation = ref($config.public.sgCmsImage);
const primary = ref(props.menu.primary);
const secondary = ref(props.menu.secondary);

// Methods
const hideDropdown = () => {
  emit('hideDropdown');
};
</script>


<style scoped>
.menu .dropdown {
  left: 0;
  top: 136px;
  border-bottom-left-radius: 26px;
  border-bottom-right-radius: 26px;
  margin-top: 17px;
  padding: 30px;
  position: absolute;
  display: none;
  box-shadow: 0px 14px 14px rgba(0, 0, 0, 0.25);
}

.mobile .dropdown {
  display: none;
}

.menu li:hover .dropdown, .mobile li.mobile-menu-header-item.expanded .dropdown, .mobile li:active .dropdown {
  display: block;
}

.dropdown ul {
  margin: 0;
  padding: 0;
}

.dropdown ul li {
  margin: 0 0;
  padding: 0;
  list-style: none;
}

.dropdown ul:last-child li:last-child {
  margin-bottom: 15px;
}

.dropdown a {
  font-weight: bold;
}

.dropdown-images ul {
  margin: 0;
  padding: 0;
}

.dropdown-images li {
  margin: 0px;
  padding: 0px;
  list-style: none;
  text-align: left;
}

.dropdown ul li a {
  padding: 10px 5px;
  display: block;
  border-radius: 5px;
}

.dropdown ul li a:hover, .dropdown ul li a:focus {
  background-color: #EEF1F4;
}

.dropdown-images img {
  width: 90%;
  height: auto;
  margin: 0 auto 5px;
  border: 2px solid #4DA43A;
  padding: 2px;
}

.services-pest-services- .dropdown-images img {
  border: 2px solid #e47907;
}

.menu .menu-border-left {
  border-left: 1px solid #abbdc8;
  padding-left: 40px;
}

.mobile .menu-border-left h4 {
  border-bottom: 1px solid #abbdc8;
  font-weight: bold;
}

</style>
